import { AccountPlan, PlanTier } from '@zapier/design-system-revenue/src/types';
import {
  formatPlanTiers,
  isTierFree,
} from '@zapier/design-system-revenue/src/utils';

const findFreeMeteredTier = (tiers: PlanTier[] = []): PlanTier => {
  return (
    tiers.find(isTierFree) || {
      numTasks: 0,
      pricePerTask: 0,
    }
  );
};

export const getNumFreeMeteredTasks = (plan: AccountPlan) => {
  return findFreeMeteredTier(formatPlanTiers(plan)).numTasks;
};
